const actions = {
  LIST_CATEGORIA_SERVICIO: 'LIST_CATEGORIA_SERVICIO',
  LIST_CATEGORIA_SERVICIO_SELECTBOX: 'LIST_CATEGORIA_SERVICIO_SELECTBOX',
  CREATE_CATEGORIA_SERVICIO: 'CREATE_CATEGORIA_SERVICIO',
  READ_CATEGORIA_SERVICIO: 'DREA_CATEGORIA_SERVICIO',
  UPDATE_CATEGORIA_SERVICIO: 'UPDATE_CATEGORIA_SERVICIO',
  DELETE_CATEGORIA_SERVICIO: 'DELETE_CATEGORIA_SERVICIO',

  categoriaServiciosList: data => {     
    return {
      type: actions.LIST_CATEGORIA_SERVICIO,
      data,
    };
  },

  categoriaServiciosListSelectBox: data => {
    return {
      type: actions.LIST_CATEGORIA_SERVICIO_SELECTBOX,
      data,
    };
  },

  categoriaServiciosCreate: data => {
    return {
      type: actions.CREATE_CATEGORIA_SERVICIO,
      data,
    };
  },

  categoriaServiciosRead: data => {
    return {
      type: actions.READ_CATEGORIA_SERVICIO,
      data,
    };
  },

  categoriaServiciosUpdate: data => {
    return {
      type: actions.UPDATE_CATEGORIA_SERVICIO,
      data,
    };
  },

  categoriaServiciosDelete: () => {
    return {
      type: actions.DELETE_CATEGORIA_SERVICIO,      
    };
  },
};

export default actions;
